import {gql} from 'graphql-request';

// Gets both the registered and discovered domains in a single query
export const companyDomainsQuery = gql`
query GetDomains($clientBoolExp: client_bool_exp) {
    client(where: $clientBoolExp)
    {
        registered_domains(order_by:{name: asc})
        {
            pub_id
            name
        }
        discovered_domains(order_by:{name :asc})
        {
            pub_id
            name
        }
    }
}`;

// Mutation for deleting a domain
export const deleteCompanyDomainMutation = gql`
mutation DeleteDomain($client_id: uuid, $req: DeleteDomainRequest!) {
  delete_company_domain(client_id:$client_id, req: $req) {
    id
  }
}`;

// Mutation for adding a new domain
export const addCompanyDomainMutation = gql`
mutation AddDomain($client_id: uuid, $req:CreateDomainRequest!){
  insert_company_domain(client_id:$client_id, req:$req) {
    id
  }
}`;
